<template>
  <div class="follow-disease">
    <a-menu
      v-model="current"
      mode="horizontal"
      @click="clickMenu"
    >
      <a-menu-item
        v-for="(item) in options"
        :key="item.type"
      >
        <div class="flexBox">
          <icon-font
            :type="item.mail"
            style="font-size:20px;"
          />
          {{ item.name }}
        </div>

      </a-menu-item>
    </a-menu>
    <p
      style="margin:10px; 0 0;fontSize:15px;"
      v-if="list.length==0"
    >暂无关注的科室</p>
    <div class="big-box">
      <div
        class="card-box"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="cont-info">
          <div class="doctor-info">
            <div
              class="doctor-title"
              style="flex:1;"
            >
              <span style="color: #999; font-size: 16px;font-weight:600;">{{
                  item.name
                }}</span>
              <span
                style="font-size:14px;margin-top:10px;"
                v-if="item.descInfo"
              >{{ item.descInfo }}</span>
            </div>
            <a-popconfirm
              title="您确定取消关注吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(item.id)"
            >
              <div class="cursor-point mycard">
                <a-icon
                  class="active"
                  style="margin-right:3px"
                  type="heart"
                  theme="filled"
                />
                <span>已关注</span>
              </div>
            </a-popconfirm>
          </div>
        </div>

      </div>
    </div>
    <div style="margin-top: 20px; padding-bottom: 20px">
      <a-pagination
        v-if="list.length > 0"
        show-quick-jumper
        :current="currPage"
        :total="totalCount"
        :defaultPageSize="form.pageSize"
        @change="onChange"
      />
    </div>
  </div>
</template>
<script>
import { myFavoriteDiseaseList } from '@/api/user-center'
import { cancelFavorite } from '@/api/registered'
import { ls } from '@/utils/tool'

export default {
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 8
      },
      current: [1],
      list: [],
      currPage: 1,
      totalCount: 1,
      sysUser: ls.get('sysUser'),
      options: [
        { name: '前十疾病', type: 1, mail: 'icon-QSJB' },
        { name: '常见疾病', type: 2, mail: 'icon-CJJB' },
        { name: '流行病', type: 3, mail: 'icon-LXB' }
      ],
      type: 1
    }
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      var res = await myFavoriteDiseaseList({ ...this.form, type: this.type })
      this.list = res.data.list || []
      this.totalCount = res.data.totalCount
      this.currPage = res.data.currPage
      if (this.list.length == 0) {
        this.$message.success('暂无关注的科室')
      }
      console.log('res.data===', res.data)
    },
    async attention(docId) {
      var data = {
        memberId: this.sysUser.id,
        objectId: docId,
        objectType: 5
      }
      var res
      res = await cancelFavorite(data)
      this.form.pageNum = 1
      this.init()
    },
    onChange(pageNumber) {
      this.form.pageNum = pageNumber
      this.init()
    },
    clickMenu(val) {
      this.type = val.key
      this.init()
    },
    confirm(val) {
      this.attention(val)
    }
  }
}
</script>
<style lang="less" scoped>
.big-box {
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 30px;
  padding-right: 3px;

  .next-page {
    margin-left: 550px;

    /deep/ li {
      width: 50px;
      height: 50px;
      line-height: 50px;
    }
  }
}

.card-box {
  cursor: pointer;
  width: 464px;
  //   height: 140px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.19);
  border-radius: 20px;
  padding: 14px 20px;
  position: relative;
  margin-bottom: 33px;

  .cont-info {
    padding: 25px 0;

    .doctor-info {
      display: flex;

      .hospitalImg {
        width: 62px;
        height: 62px;
        margin-right: 25px;
        overflow: hidden;
        border-radius: 50%;

        img {
          height: 62px;
        }
      }

      .doctor-title {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        font-weight: 400;
        color: #666;

        > div {
          .leval {
            display: inline-block;
            padding: 5px 10px;
            background: #ffc7bc;
            color: #ff0000;
            margin-right: 15 rpx;
          }
        }
      }

      .mycard {
        height: 0;
        font-size: 16px;
        color: red;

        span {
          color: #333333;
        }
      }
    }

    .patient-box {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      margin-top: 8px;

      .patient-title {
        font-weight: 400;
        color: #333333;
      }

      .patient-name {
        color: #666;
      }
    }
  }

  .card-btn {
    width: 90px;
    height: 34px;
    background: #459df7;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    color: #fff;
    font-size: 16px;
    position: absolute;
    top: 45px;
    right: 55px;

    .active {
      color: #d81e06;
    }
  }
}

.flexBox {
  display: flex;
  align-items: center;
}
</style>
